/**
 * Indicates the type of media currently loading/loaded.
 */
export var MediaType;
(function (MediaType) {
    MediaType["Unknown"] = "unknown";
    MediaType["Audio"] = "audio";
    MediaType["Video"] = "video";
    MediaType["LiveVideo"] = "live-video";
})(MediaType || (MediaType = {}));
